import {ContactForm} from '../../../../../../services/cellcast.v2.types'
import {Button, Modal, OverlayTrigger, Tooltip} from 'react-bootstrap'
import {FC, useEffect, useState} from 'react'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'
import './HtmlForm.css'

export type HtmlFormProps = {
  show: boolean
  contactForm?: ContactForm
  handleClose: () => void
}

const HtmlForm: FC<HtmlFormProps> = (props) => {
  const {contactForm, show, handleClose} = props
  const [copyText, setCopyText] = useState('Copy Code')

  const [htmlCode, setHtmlCode] = useState("")

  // Function to copy code
  const copyToClipboard = () => {
    navigator.clipboard.writeText(htmlCode)
    setCopyText('Copied!')
    setTimeout(() => setCopyText('Copy Code'), 2000) // Reset tooltip after 2 sec
  }

  useEffect(() => {
    if(contactForm){
        setHtmlCode(generateContactForm(contactForm))
    }
  }, [contactForm])

  return (
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-700px h-auto'
      show={show}
      onHide={handleClose}
    >
      <div className='scroll-x'>
        <div className='modal-header'>
          <h2 className='fs-2'>HTML Form {contactForm?.name ? ` - ${contactForm?.name}` : ''}</h2>
          <div
            className='btn btn-icon btn-sm'
            onClick={() => {
              handleClose()
            }}
          >
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body py-lg-5 px-lg-5 border-bottom d-flex flex-column mb-10'>
          <div className='mb-5 d-flex p-5'>
            <pre className='code-block'>{htmlCode}</pre>
          </div>
        </div>
        <Modal.Footer>
          {/* Tooltip Button for Copy */}
          <OverlayTrigger placement='top' overlay={<Tooltip id='copy-tooltip'>{copyText}</Tooltip>}>
            <Button variant='secondary' onClick={copyToClipboard}>
              📋 Copy Code
            </Button>
          </OverlayTrigger>

          <Button variant='info' onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  )
}

function generateContactForm(contactForm: ContactForm): string {
    const actionUrl = `${ENV().REACT_APP_API_URL}contact-form-public/${contactForm._id}/action`;
    
    let formHtml = `
<form action="${actionUrl}" method="post" enctype="multipart/form-data">
    <input name="redirectUrl" type="hidden" value="" />
`;
    
    contactForm.fields.forEach(field => {
        formHtml += `    <div>
          <label for="${field.name}">${field.name}:</label>
          <input type="${field.type}" id="${field.name}" name="${field.name}" required>
    </div>

`;
    });

    formHtml += `    <div style="margin: 15px 0;">
      <input type="checkbox" id="confirm" name="confirm" required>
      <label for="confirm">I confirm the above information is correct</label>
    </div>`
    formHtml += `      
    <button type="submit">Submit</button>
</form>
`;
    
    return formHtml;
}


export default HtmlForm

